import React, { Fragment, useEffect, useState } from 'react'
import { Row, Col, Container, Table } from 'reactstrap'
import { Drawer } from '@material-ui/core'
import { TextFieldHookForm, SearchableSelectHookForm } from '../../../../src/components/layout/HookFormInputs'
import { useForm, Controller } from 'react-hook-form'
import NoContentFound from '../../../../src/components/common/NoContentFound'
import { reactLocalStorage } from 'reactjs-localstorage'
import { number, checkWhiteSpaces, percentageLimitValidation, decimalNumberLimit6, checkForNull, checkForDecimalAndNull, hashValidation, maxLength80, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide } from "../../../../src/helper/validation";
import { useDispatch, useSelector } from 'react-redux'
import { COMMODITYCOST, EMPTY_DATA, RAWMATERIALCOST } from '../../../../src/config/constants'
import Toaster from '../../../../src/components/common/Toaster';
import { getCostingCondition } from '../../../actions/Common'
import { generateCombinations, getCostingConditionTypes, handleApplicability } from '../../common/CommonFunctions'
import TooltipCustom from '../../common/Tooltip'

function AddOtherCostDrawer(props) {
    const initialConfiguration = useSelector((state) => state.auth.initialConfiguration)
    const dispatch = useDispatch();



    const { rmBasicRate, isFromImport, RowData, RowIndex, isImport, plantCurrency, settlementCurrency, isBOP, RawMaterialNonIndexed = true, bopBasicRate } = props
    const Currency = RawMaterialNonIndexed ? settlementCurrency : ((isBOP && isImport) ? settlementCurrency : isBOP && !isImport ? plantCurrency : props?.RowData?.IndexCurrency) || 'Currency'
    // Fixed CurrencyLabel logic in single line to handle both domestic and import cases properly
    const CurrencyLabel = (RawMaterialNonIndexed ? (settlementCurrency || plantCurrency) : (!props.rawMaterial ? reactLocalStorage.getObject('baseCurrency') : isImport && (props.rawMaterial || isBOP) ? (settlementCurrency || plantCurrency) : plantCurrency)) || 'Currency'
    const UOM = props?.RowData?.IndexUOM || (Array.isArray(props?.uom) ? '' : props?.uom?.label) || '';
    const [tableData, setTableData] = useState([]);

    const [disableTotalCost, setDisableTotalCost] = useState(true)
    const [disableAllFields, setDisableAllFields] = useState(true)
    const [editIndex, setEditIndex] = useState('')
    const [isEditMode, setIsEditMode] = useState(false)
    const [isEditingDependedRow, setIsEditingDependedRow] = useState(false)
    const [type, setType] = useState('')
    const [totalCostCurrency, setTotalCostCurrency] = useState('')
    const [totalCostBase, setTotalCostBase] = useState('')
    const [disableCurrency, setDisableCurrency] = useState(false)
    const [availableApplicabilities, setAvailableApplicabilities] = useState(["Basic Rate"]);
    const [RawMaterialCommodityIndexRateAndOtherCostDetailsId, setRawMaterialCommodityIndexRateAndOtherCostDetailsId] = useState('')
    const ExchangeRate = RowData?.ExchangeRate
    const BasicRateIndexCurrency = RowData?.BasicRate
    const [state, setState] = useState({
        Applicability: false,
        rowData: {},
        disableApplicability: true,
        premiumCost: '',
        disableCostCurrency: false,
        disableCostBaseCurrency: false,
        costDropdown: []
    })
    const [exactCostValues, setExactCostValues] = useState({
        ApplicabilityCostCurrency: '',
        ApplicabilityBaseCost: '',
        CostCurrency: '',
        CostBaseCurrency: ''
    });
    const conditionTypeId = getCostingConditionTypes(props.rawMaterial ? RAWMATERIALCOST : COMMODITYCOST)
    useEffect(() => {
        if (!tableData || tableData.length === 0) {
            setTotalCostBase(0);
            setTotalCostCurrency(0);
            return;
        }

        // Filter out "Discount Cost" entries
        const filteredTableData = tableData.filter(obj => obj.CostHeaderName !== "Discount Cost");

        // Calculate the sum for NetCostConversion excluding "Discount Cost" using precise addition
        const sumNetCostConversion = filteredTableData.reduce((acc, obj) =>
            preciseAdd(acc, checkForNull(obj.NetCostConversion)), 0);

        // Calculate the sum for NetCost excluding "Discount Cost" using precise addition
        const sumNetCost = filteredTableData.reduce((acc, obj) =>
            preciseAdd(acc, checkForNull(obj.NetCost)), 0);

        // Find the first "Discount Cost" entry, if any
        const discountCostEntry = tableData?.find(obj => obj.CostHeaderName === "Discount Cost");
        let discountNetCostConversion = 0;
        let discountNetCost = 0;

        if (discountCostEntry) {
            // Ensure discount is always treated as a negative value for calculation
            // If the API returns a positive value, convert it to negative
            // If the API returns a negative value, keep it as is
            const rawDiscountValueConversion = checkForNull(discountCostEntry.NetCostConversion);
            const rawDiscountValueCost = checkForNull(discountCostEntry.NetCost);
            
            discountNetCostConversion = rawDiscountValueConversion >= 0 ? -Math.abs(rawDiscountValueConversion) : rawDiscountValueConversion;
            discountNetCost = rawDiscountValueCost >= 0 ? -Math.abs(rawDiscountValueCost) : rawDiscountValueCost;
        }

        // Calculate the final totalCostBase by applying the discount using precise addition
        // Since discountNetCostConversion is now guaranteed to be negative, we add it (which effectively subtracts)
        const totalCostBase = preciseAdd(sumNetCostConversion, discountNetCostConversion);
        const totalCostCurrency = preciseAdd(sumNetCost, discountNetCost);

        // Check if the tableData contains only "Discount Cost" entries
        const isOnlyDiscountCost = tableData.every(obj => obj.CostHeaderName === "Discount Cost");

        // Update state
        setTotalCostBase(isOnlyDiscountCost ? discountNetCostConversion : totalCostBase);
        setTotalCostCurrency(isOnlyDiscountCost ? discountNetCost : totalCostCurrency);
               
    }, [tableData]);
    useEffect(() => {
        if (props.rawMaterial === true || isBOP) {
            setTableData(props.rmTableData || [])
        } else {
            if (Array.isArray(props.RowData?.RawMaterialCommodityIndexRateDetailsRequest)) {
                const filteredData = props?.tableData?.filter(item =>
                    props.RowData.RawMaterialCommodityIndexRateDetailsRequest.some(req =>
                        req.RawMaterialCommodityIndexRateAndOtherCostDetailsId === item.RawMaterialCommodityIndexRateAndOtherCostDetailsId
                    )
                );
                setTableData(filteredData);
            } else {
                setTableData([]);
            }
        }
    }, [props.RowData, props.tableData]);
    useEffect(() => {
        dispatch(getCostingCondition('', conditionTypeId, (res) => {
            if (res?.data?.DataList) {
                const temp = res?.data?.DataList?.map((item) => ({
                    label: item?.CostingConditionNumber,
                    value: item?.CostingConditionMasterId,
                }));
                setState((prevState) => ({
                    ...prevState,
                    costDropdown: temp
                }));
            }
        }));
    }, [])

    // Add a new useEffect to process the data when cost dropdown is available
    useEffect(() => {
        if ((props.rawMaterial === true || isBOP) && state.costDropdown?.length > 0 && tableData?.length > 0) {
            // Process the data to ensure CostHeaderName is not null
            const processedTableData = tableData.map(item => {
                // If CostHeaderName is null, try to get it from CostingConditionMasterId
                if (!item.CostHeaderName && item.CostingConditionMasterId) {
                    // Find the corresponding cost header name from the dropdown
                    const costItem = state.costDropdown.find(cost => cost.value === item.CostingConditionMasterId);
                    if (costItem) {
                        return {
                            ...item,
                            CostHeaderName: costItem.label
                        };
                    }
                }
                return item;
            }).filter(item => item.CostHeaderName); // Filter out items without CostHeaderName
            
            // Only update if there are changes
            if (JSON.stringify(processedTableData) !== JSON.stringify(tableData)) {
                setTableData(processedTableData);
            }
        }
    }, [state.costDropdown]);

    useEffect(() => {
        updateAvailableApplicabilities();
    }, [tableData, state.costDropdown]);
    const updateAvailableApplicabilities = () => {
        const newApplicabilities = ["Basic Rate"];
        tableData?.forEach(item => {
            if (item.CostHeaderName !== "Basic Rate" && !newApplicabilities.includes(item.CostHeaderName)) {
                newApplicabilities.push(item.CostHeaderName);
            }
        });
        setAvailableApplicabilities(newApplicabilities);
    };

    /**
     * @method isCostDependedUpon
     * @description Checks if a cost is used as a dependency in any other row's Applicability
     * @param {string} costHeaderName - The cost header name to check
     * @param {number} currentIndex - The index of the current row (to exclude from check)
     * @returns {boolean} - True if the cost is depended upon by other rows
     */
    const isCostDependedUpon = (costHeaderName, currentIndex) => {
        if (!tableData || tableData.length === 0) return false;

        // Check if any other row's Applicability contains this cost name
        return tableData.some((item, index) => {
            // Skip the current row
            if (index === currentIndex) return false;

            // Skip if applicability is not set or is just "Basic Rate"
            if (!item.Applicability || item.Applicability === '-' || item.Applicability === 'Basic Rate') return false;

            // Split the applicability by ' + ' and check if it contains the cost header name
            const applicabilityParts = item.Applicability.split(' + ');
            return applicabilityParts.includes(costHeaderName);
        });
    };

    /**
     * @method recalculateDependentRows
     * @description Recalculates rows using Topological Sort (Kahn's Algorithm) - O(n).
     * Guarantees dependencies are always processed before dependents.
     */
    const recalculateDependentRows = (data) => {
        if (!data || data.length === 0) return data;

        const basicRate = props.rawMaterial ? rmBasicRate : (props.isBOP ? bopBasicRate : BasicRateIndexCurrency);
        const costField = props.isBOP ? 'NetCost' : 'NetCostConversion';
        const result = data.map(row => ({ ...row }));

        // Build dependency graph
        const indexMap = new Map(result.map((row, i) => [row.CostHeaderName, i]));
        const inDegree = new Array(data.length).fill(0);
        const dependents = new Map();

        result.forEach((row, i) => {
            if (row.Type === 'Percentage' && row.Applicability && row.Applicability !== '-') {
                row.Applicability.split(' + ').forEach(dep => {
                    if (dep !== 'Basic Rate' && indexMap.has(dep)) {
                        inDegree[i]++;
                        const depIdx = indexMap.get(dep);
                        dependents.set(depIdx, [...(dependents.get(depIdx) || []), i]);
                    }
                });
            }
        });

        // Process in topological order using BFS
        const queue = inDegree.map((d, i) => d === 0 ? i : -1).filter(i => i >= 0);

        while (queue.length) {
            const i = queue.shift();
            const row = result[i];

            if (row.Type === 'Percentage' && row.Applicability && row.Applicability !== '-') {
                const total = handleApplicability(row.Applicability, basicRate, result, costField, 'CostHeaderName', 'Basic Rate');
                const pct = preciseDivide(checkForNull(row.Value), 100);
                const netCost = preciseMultiply(pct, total);
                const netCostConv = props.rawMaterial ? netCost : preciseMultiply(netCost, ExchangeRate);

                result[i] = { ...row,
                    ApplicabilityCost: total,
                    ApplicabilityCostConversion: props.rawMaterial ? total : preciseMultiply(total, ExchangeRate),
                    NetCost: props.rawMaterial ? netCostConv : netCost,
                    NetCostConversion: netCostConv
                };
            }

            (dependents.get(i) || []).forEach(d => { if (--inDegree[d] === 0) queue.push(d); });
        }

        return result;
    };
    const editData = (indexValue, operation) => {
        if (operation === 'delete') {
            handleDelete(indexValue);
        } else if (operation === 'edit') {
            handleEdit(indexValue);
        }

    }
    const handleEdit = (indexValue) => {
        setEditIndex(indexValue);
        setIsEditMode(true);

        let selectedData = tableData[indexValue];

        // Check if this row is depended upon by other rows
        const isDependedUpon = isCostDependedUpon(selectedData.CostHeaderName, indexValue);
        setIsEditingDependedRow(isDependedUpon);

        // For Discount Cost, use absolute values for editing
        const isDiscountCost = selectedData.CostHeaderName === "Discount Cost";
        const netCostValue = isDiscountCost ? Math.abs(selectedData.NetCost) : selectedData.NetCost;
        const netCostConversionValue = isDiscountCost ? Math.abs(selectedData.NetCostConversion) : selectedData.NetCostConversion;

        // Store raw values in exactCostValues state
        setExactCostValues({
            ApplicabilityCostCurrency: selectedData.ApplicabilityCost,
            ApplicabilityBaseCost: selectedData.ApplicabilityCostConversion,
            CostCurrency: netCostValue,
            CostBaseCurrency: isBOP || RawMaterialNonIndexed ? netCostValue : netCostConversionValue
        });

        setValue('Cost', {
            label: selectedData.CostHeaderName,
            value: selectedData.CostingConditionMasterId
        });
        setValue('Type', {
            label: selectedData.Type,
            value: selectedData.Type
        });
        setType({
            label: selectedData.Type,
            value: selectedData.Type
        });
        setValue('Percentage', selectedData.Value);
        setValue('Applicability', {
            label: selectedData.Applicability,
            value: selectedData.Applicability
        });
        setValue('ApplicabilityCostCurrency', checkForDecimalAndNull(selectedData.ApplicabilityCost, initialConfiguration?.NoOfDecimalForPrice));
        setValue('ApplicabilityBaseCost', isBOP ? checkForDecimalAndNull(selectedData.ApplicabilityCost, initialConfiguration?.NoOfDecimalForPrice) : checkForDecimalAndNull(selectedData.ApplicabilityCostConversion, initialConfiguration?.NoOfDecimalForPrice));
        setValue('CostCurrency', checkForDecimalAndNull(netCostValue, initialConfiguration?.NoOfDecimalForPrice));
        setValue('CostBaseCurrency', isBOP || RawMaterialNonIndexed ? checkForDecimalAndNull(netCostValue, initialConfiguration?.NoOfDecimalForPrice) : checkForDecimalAndNull(netCostConversionValue, initialConfiguration?.NoOfDecimalForPrice));
        setValue('CostDescription', selectedData.Description);
        setValue('Remark', selectedData.Remark);
        setRawMaterialCommodityIndexRateAndOtherCostDetailsId(selectedData?.RawMaterialCommodityIndexRateAndOtherCostDetailsId ?? null)
        // setTotalCostCurrency(selectedData.CostCurrency);
        // setType(selectedData.ConditionType);

        // Update UI state based on the type
        // if (selectedData.Type === 'Fixed') {
        //     setDisableTotalCost(false);
        //     setDisableCurrency(false);

        //     setDisableAllFields(true);
        // } else {
        //     setState(prevState => ({ ...prevState, disableApplicability: false }));
        // }
    };

    const handleDelete = (indexValue) => {
        let updatedData = tableData.filter((_, index) => index !== indexValue);
        // Recalculate dependent rows after deletion to ensure all values are up to date
        const recalculatedData = recalculateDependentRows(updatedData);
        setTableData(recalculatedData);
        resetData();
    };

    const editDeleteData = (indexValue, operation) => {

        editData(indexValue, operation)
    }

    const { register, control, setValue, getValues, handleSubmit, reset, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })
    const toggleCondition = () => {
        let cssClass = '';
        if (isFromImport) {
            if (type === "") {
                cssClass = 'mb-3';
            } else if (type === "Fixed") {
                cssClass = 'mb-3';
            } else {
                cssClass = 'mt-4 pt-1';
            }
        } else {
            if (type === "") {
                cssClass = 'mt-4 pt-1';
            } else if (type === "Fixed") {
                cssClass = 'mb-3';
            } else {
                cssClass = 'mt-4 pt-1 mb-5 pb-3';
            }
            if (props.isFromMaster) {
                if (type === "Percentage") {
                    cssClass = 'mb-3';
                } else {
                    cssClass = 'mt-4 pt-1 mb-5 pb-1';
                }
            }
        }
        return cssClass
    }
    const applicabilityChange = (e) => {
        // Reset dependent fields when applicability changes
        setValue('Percentage', '');
        setValue('CostCurrency', '');
        setValue('CostBaseCurrency', '');
        setExactCostValues(prev => ({
            ...prev,
            CostCurrency: '',
            CostBaseCurrency: ''
        }));

        // Handle Basic Rate separately
        if (e?.label === 'Basic Rate') {
            let basicRate = props.rawMaterial ? rmBasicRate : BasicRateIndexCurrency * ExchangeRate
            setExactCostValues({
                ApplicabilityCostCurrency: BasicRateIndexCurrency,
                ApplicabilityBaseCost: basicRate
            });
            setValue('ApplicabilityCostCurrency', checkForDecimalAndNull(BasicRateIndexCurrency, initialConfiguration?.NoOfDecimalForPrice));
            setValue('ApplicabilityBaseCost', checkForDecimalAndNull(basicRate, initialConfiguration?.NoOfDecimalForPrice));
            setState(prevState => ({ ...prevState, Applicability: e?.label }));
            return; // Exit early for Basic Rate
        }

        // For other applicabilities
        // Check which applicabilities are selected
        const selectedApplicabilities = e?.label?.split(' + ');

        // Calculate total cost currency for selected applicabilities
        let totalCostCurrency = 0;
        let allExist = true;
        let missingCosts = []; // Array to hold missing costs
        let totalBasicRate
        let total

        selectedApplicabilities.forEach(Applicability => {
            // Skip checking for "Basic Rate" in tableData
            if (Applicability === 'Basic Rate') {
                return;
            }
            const item = tableData.find(item => item?.CostHeaderName === Applicability);
            if (item) {
                totalCostCurrency = preciseAdd(totalCostCurrency, props.isBOP ? checkForNull(item?.NetCost) : checkForNull(item?.NetCostConversion));
                if (selectedApplicabilities.includes('Basic Rate')) {
                    totalBasicRate = props.rawMaterial ? rmBasicRate : BasicRateIndexCurrency
                    total = preciseAdd(checkForNull(totalCostCurrency), checkForNull(totalBasicRate))
                } else {
                    total = checkForNull(totalCostCurrency)
                }
            } else {
                // Add missing Applicability to the array
                missingCosts.push(Applicability);
                // Set flag to indicate not all applicabilities exist
                allExist = false;
            }
        });

        // If not all applicabilities exist, handle the condition
        if (!allExist) {
            // Show toaster message with all missing costs
            Toaster.warning(`Cost(s) for ${missingCosts.join(', ')} do not exist in the table, please add data first before proceeding further`);
            // Reset all dependent fields when applicability is invalid
            setValue('ApplicabilityCostCurrency', '');
            setValue('ApplicabilityBaseCost', '');
            setValue('Percentage', '');
            setValue('CostCurrency', '');
            setValue('CostBaseCurrency', '');
            setExactCostValues({
                ApplicabilityCostCurrency: '',
                ApplicabilityBaseCost: '',
                CostCurrency: '',
                CostBaseCurrency: ''
            });
            // Reset applicability selection to force user to select again
            setValue('Applicability', '');
            setState(prevState => ({ ...prevState, Applicability: '' }));
        } else {
            // Set ApplicabilityCostCurrency and ApplicabilityBaseCost if all exist
            const totalBaseCost = props.rawMaterial ? total : preciseMultiply(total, ExchangeRate);
            setExactCostValues({
                ApplicabilityCostCurrency: total,
                ApplicabilityBaseCost: totalBaseCost
            });
            setValue('ApplicabilityCostCurrency', checkForDecimalAndNull(total, initialConfiguration?.NoOfDecimalForPrice));
            setValue('ApplicabilityBaseCost', checkForDecimalAndNull(totalBaseCost, initialConfiguration?.NoOfDecimalForPrice));
        }

        setState(prevState => ({ ...prevState, Applicability: e?.label }));
    }
    const onPercentChange = (e) => {
        if (e?.target?.value) {
             // Use exact values from state for calculation
            let applicabilityCostCurrency = props.rawMaterial
                ? exactCostValues.ApplicabilityBaseCost
                : exactCostValues.ApplicabilityCostCurrency;
            const percentageDecimal = preciseDivide(checkForNull(e.target.value), 100);
            let NetCost = preciseMultiply(percentageDecimal, checkForNull(applicabilityCostCurrency));
            let NetCostConversion = props.rawMaterial ? NetCost : preciseMultiply(NetCost, ExchangeRate);
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: NetCost,
                CostBaseCurrency: NetCostConversion
            }));
            setValue('CostCurrency', checkForDecimalAndNull(NetCost, initialConfiguration?.NoOfDecimalForPrice))
            setValue('CostBaseCurrency', checkForDecimalAndNull(NetCostConversion, initialConfiguration?.NoOfDecimalForPrice))
        }
    }

    const cancel = () => {
        props.closeDrawer('Cancel', tableData, totalCostCurrency, totalCostBase, RowIndex)
    }


    const handleCostChangeCurrency = (e) => {
        if (e?.target?.value) {
            const exactValue = checkForNull(e.target.value);
            const exactBaseValue = preciseMultiply(exactValue, ExchangeRate);

            // Store exact values
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: exactValue,
                CostBaseCurrency: exactBaseValue
            }));

            // Set formatted values
            setValue('CostBaseCurrency', checkForDecimalAndNull(exactBaseValue, initialConfiguration?.NoOfDecimalForPrice));
            setState(prevState => ({ ...prevState, disableCostBaseCurrency: true }));
        } else {
            setValue('CostBaseCurrency', '');
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: '',
                CostBaseCurrency: ''
            }));
            setState(prevState => ({ ...prevState, disableCostBaseCurrency: false }));
        }
    }
    const handleCostChangeBase = (e) => {
        if (e?.target?.value) {
            const exactBaseValue = checkForNull(e.target.value);
            const exactValue = preciseDivide(exactBaseValue, ExchangeRate);

            // Store exact values
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: exactValue,
                CostBaseCurrency: exactBaseValue
            }));

            // Set formatted values
            setValue('CostCurrency', checkForDecimalAndNull(exactValue, initialConfiguration?.NoOfDecimalForPrice));
            setState(prevState => ({ ...prevState, disableCostCurrency: true }));
        } else {
            setValue('CostCurrency', '');
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: '',
                CostBaseCurrency: ''
            }));
            setState(prevState => ({ ...prevState, disableCostCurrency: false }));
        }
    }

    /**
    * @method renderListing
    * @description RENDER LISTING IN DROPDOWN
    */
    const renderListing = (label) => {
        if (label === 'Type') {
            return [
                { label: "Percentage", value: "Percentage" },
                { label: "Fixed", value: 'Fixed' }
            ]
        }
        return [];
    }

    const combinations = generateCombinations(availableApplicabilities, "Basic Rate");

    // Add this helper function to format display values (hide negative signs for discount costs)
    const formatDisplayValue = (value, costHeaderName) => {
        if (costHeaderName === "Discount Cost") {
            // For discount costs, show absolute value (hide negative sign) in UI
            return Math.abs(checkForNull(value));
        }
        // For other costs, show as is
        return checkForNull(value);
    };

    const onSubmit = data => {
        addData();
    }
    const addData = () => {
        const type = getValues('Type');
        const cost = getValues('Cost');
        const applicability = getValues('Applicability');
        const percentage = Number(getValues('Percentage'));
        const costBaseCurrency = getValues('CostBaseCurrency');
        const applicabilityBaseCost = getValues('ApplicabilityBaseCost');
        const remark = getValues('Remark');
        const costDescription = getValues('CostDescription');

        // Check for form errors first
        if (Object.keys(errors).length > 0) {
            Toaster.warning('Please fix all validation errors before adding.');
            return false;
        }


        // If 'Type' is not provided, return false
        if (!type || !cost || !remark || !costDescription) { Toaster.warning('Please enter all mandatory details to add a row.'); return false };
        if (type.label === "Percentage") {
            // If 'Type' is 'percentage', check for 'Applicability' and 'Percentage'
            if (!applicability || !applicabilityBaseCost || !percentage || percentage === 0) {
                Toaster.warning('Cost should not be zero or empty.');
                return false;
            }
        } else if (type.label === 'Fixed') {
            // If 'Type' is 'fixed', check for 'CostCurrency' and 'CostBaseCurrency'
            if (!costBaseCurrency) { Toaster.warning('Please enter all details to add a row.'); return false };
        }
        // Create new data entry
        const newData = {
            MaterialCommodityStandardDetailsId: RowData?.MaterialCommodityStandardDetailsId, // Add MaterialCommodityStandardDetailsId
            RawMaterialCommodityIndexRateAndOtherCostDetailsId: RawMaterialCommodityIndexRateAndOtherCostDetailsId ?? null,
            Type: getValues('Type') ? getValues('Type').label : '-',
            CostHeaderName: getValues('Cost') ? getValues('Cost').label : '-',
            Applicability: getValues('Applicability') ? getValues('Applicability').label : '-',
            ApplicabilityCost: props.rawMaterial ? exactCostValues.ApplicabilityBaseCost : exactCostValues.ApplicabilityCostCurrency ? exactCostValues.ApplicabilityCostCurrency : '-',
            ApplicabilityCostConversion: exactCostValues.ApplicabilityBaseCost ? exactCostValues.ApplicabilityBaseCost : '-',
            Value: getValues('Percentage') ? getValues('Percentage') : '-',
            NetCost: props.rawMaterial ? exactCostValues.CostBaseCurrency : exactCostValues.CostCurrency,
            NetCostConversion: exactCostValues.CostBaseCurrency,
            Description: getValues('CostDescription') ? getValues('CostDescription') : '-',
            CostingConditionMasterId: getValues('Cost') ? getValues('Cost').value : '-',
            Remark: getValues('Remark')
        };
        // Validation for Discount Cost
        if (newData.CostHeaderName === 'Discount Cost') {
            // Calculate current net cost (basic rate + all other costs except discount) using precise calculation
            const basicRate = props.rawMaterial ? rmBasicRate : (props.isBOP ? bopBasicRate : preciseMultiply(BasicRateIndexCurrency, ExchangeRate));
            const filteredTableData = tableData.filter(obj => obj.CostHeaderName !== "Discount Cost");
            const sumOtherCosts = filteredTableData.reduce((acc, obj) =>
                preciseAdd(acc, checkForNull(obj.NetCostConversion)), 0);
            const currentNetCost = preciseAdd(checkForNull(basicRate), sumOtherCosts);

            // Check if discount exceeds net cost
            const discountAmount = props.rawMaterial ? checkForNull(newData.NetCostConversion) : checkForNull(newData.NetCost);
            
            if (checkForNull(discountAmount) >= checkForNull(currentNetCost)) {
                Toaster.warning('Discount cost cannot be greater than or equal to the net cost (Basic Rate + Other Costs)');
                return false;
            }

            // Check if net cost after discount would be negative or zero
            const netCostAfterDiscount = preciseSubtract(currentNetCost, discountAmount);
            if (netCostAfterDiscount <= 0) {
                Toaster.warning('Net cost after discount cannot be zero or negative');
                return false;
            }

            // Store as negative number (ensure it's always negative regardless of input)
            newData.NetCost = -Math.abs(newData.NetCost);
            newData.NetCostConversion = -Math.abs(newData.NetCostConversion);
        }
        // Assuming 'tableData' is an array of objects and you want to add MaterialCommodityStandardDetailsId separately,
        // you can structure your updated data as follows:
        const updatedData = {
            MaterialCommodityStandardDetailsId: RowData?.MaterialCommodityStandardDetailsId,
            data: [] // This will hold your actual tableData with the new item added if necessary
        };

        // Check if CostHeaderName already exists in tableData, excluding the current item in edit mode
        const isCostValueExists = tableData && tableData.some((item, index) => {
            if (isEditMode && index === editIndex) {
                return false; // Skip the current edited item
            }
            return item.CostHeaderName === newData.CostHeaderName;
        });

        if (isCostValueExists) {
            // Display toaster warning if CostHeaderName already exists
            Toaster.warning('Cost already exists in the table.');
            return; // Exit function early
        }

        // Update tableData state
        if (isEditMode) {
            const updatedTableData = [...tableData];
            updatedTableData[editIndex] = newData;
            updatedData.data = updatedTableData;
        } else {
            updatedData.data = [...tableData, newData];
        }

        // Recalculate dependent rows after adding/updating a row
        const recalculatedData = recalculateDependentRows(updatedData.data);
        setTableData(recalculatedData);

        // Reset input fields and states
        resetData(); // Assuming resetData correctly resets form inputs
        setIsEditMode(false);
        setEditIndex('');

        // Reset dropdowns to their initial state (placeholder)
        setValue('Cost', ''); // Reset to an empty string or null to show the placeholder
        setValue('Type', ''); // Reset to an empty string or null to show the placeholder
        setValue('Percentage', ''); // Reset Percentage field
        setValue('CostCurrency', ''); // Reset to an empty string or null to show the placeholder
        setValue('CostBaseCurrency', '');
        setValue('CostDescription', '');
        setState(prevState => ({ ...prevState, disableCostBaseCurrency: false, disableCostCurrency: false }));
    };
    const resetData = (type = '') => {
        const commonReset = () => {
            setDisableAllFields(true);
            setDisableTotalCost(true);
            setType('');
            setEditIndex('');
            setIsEditMode(false)
            setIsEditingDependedRow(false)
            setExactCostValues({
                ApplicabilityCostCurrency: '',
                ApplicabilityBaseCost: '',
                CostCurrency: '',
                CostBaseCurrency: ''
            });
            reset({
                Cost: '',
                Type: '',
                Percentage: '',
                CostCurrency: '',
                CostBaseCurrency: '',
                CostDescription: '',
                Remark: ''
            });
        };
        commonReset();
    };

    const handleType = (type) => {
        if (type && type !== '') {
            setType(type);
            setValue('CostCurrency', '')
            setValue('CostBaseCurrency', '')
            setValue('Percentage', '')
            setValue('Applicability', '')
            setValue('ApplicabilityCostCurrency', '')
            setValue('ApplicabilityBaseCost', '')
            // Reset exactCostValues to ensure Applicability Cost is cleared
            setExactCostValues({
                ApplicabilityCostCurrency: '',
                ApplicabilityBaseCost: '',
                CostCurrency: '',
                CostBaseCurrency: ''
            });
            if (type?.label === "Percentage") {
                setState(prevState => ({ ...prevState, disableApplicability: false }));
            } else {
                setState(prevState => ({ ...prevState, disableApplicability: true }));
            }
        } else {
            setType('');
        }
    }

    return (

        <div>
            <Drawer anchor={props.anchor} open={props.isOpen}
            >
                <div className={`ag-grid-react hidepage-size`}>
                    <Container className="add-bop-drawer">
                        <div className={'drawer-wrapper layout-min-width-1000px'}>

                            <Row className="drawer-heading">
                                <Col className="pl-0">
                                    <div className={'header-wrapper left'}>
                                        <h3>{'Other Cost:'}</h3>
                                    </div>
                                    <div
                                        onClick={cancel}
                                        className={'close-button right'}>
                                    </div>
                                </Col>
                            </Row>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='hidepage-size'>

                                    <Row>
                                        <Col md="3" className='px-2'>
                                            <SearchableSelectHookForm
                                                label={`Cost`}
                                                name={'Cost'}
                                                placeholder={'Select'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                // options={conditionDropdown}
                                                options={state.costDropdown}

                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.Cost}
                                                disabled={props.ViewMode || isEditMode}
                                            />
                                        </Col>
                                        <Col md="3" className='px-2'>
                                            <TextFieldHookForm
                                                label="Cost Description"
                                                name={"CostDescription"}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces, hashValidation, maxLength80 },

                                                }}
                                                handleChange={() => { }}
                                                defaultValue={""}
                                                className=""
                                                customClassName={"withBorder"}
                                                errors={errors.CostDescription}
                                                disabled={props.ViewMode}
                                            />
                                        </Col>
                                        <Col md={3} className='px-2'>
                                            <SearchableSelectHookForm
                                                label={`Type`}
                                                name={'Type'}
                                                placeholder={'Select'}

                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                options={renderListing('Type')}
                                                handleChange={handleType}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.Type}
                                                disabled={props.ViewMode}
                                            />
                                        </Col>

                                        {
                                            type.label === 'Percentage' &&
                                            <>
                                                <Col md="3" className='px-2'>
                                                    <SearchableSelectHookForm
                                                        label={`Applicability`}
                                                        name={'Applicability'}
                                                        placeholder={'Select'}
                                                        Controller={Controller}
                                                        control={control}
                                                        register={register}
                                                        mandatory={true}
                                                        options={combinations}
                                                        handleChange={applicabilityChange}
                                                        defaultValue={''}
                                                        className=""
                                                        customClassName={'withBorder'}
                                                        errors={errors.Applicability}
                                                        disabled={props.ViewMode || isEditingDependedRow}
                                                    />
                                                </Col>
                                                {!props.rawMaterial && <Col md={3} className={'px-2'}>
                                                    <TextFieldHookForm
                                                        label={`Applicability Cost (${Currency}${UOM ? `/${UOM}` : ''})`}
                                                        name={'ApplicabilityCostCurrency'}
                                                        id={'cost-by-percent'}
                                                        Controller={Controller}
                                                        control={control}
                                                        register={register}
                                                        mandatory={true}
                                                        rules={props.ViewMode || disableTotalCost || disableCurrency ? {} : {
                                                            required: true,
                                                            validate: { number, checkWhiteSpaces, decimalNumberLimit6 },
                                                        }}
                                                        handleChange={() => { }}
                                                        defaultValue={''}
                                                        className=""
                                                        customClassName={'withBorder'}
                                                        errors={errors.ApplicabilityCostCurrency}
                                                        disabled={props.ViewMode || disableTotalCost || disableCurrency}
                                                    />
                                                </Col>}
                                                <Col md={3} className={'px-2'}>

                                                    <TextFieldHookForm
                                                        label={`Applicability Cost (${CurrencyLabel}${UOM ? `/${UOM}` : ''})`}
                                                        name={'ApplicabilityBaseCost'}
                                                        id={'cost-by-percent'}
                                                        Controller={Controller}

                                                        control={control}
                                                        register={register}
                                                        mandatory={true}
                                                        rules={{
                                                            required: true,
                                                            validate: { number, checkWhiteSpaces, decimalNumberLimit6 },
                                                        }}
                                                        handleChange={() => { }}
                                                        defaultValue={''}
                                                        className=""
                                                        customClassName={'withBorder'}
                                                        errors={errors.ApplicabilityBaseCost}
                                                        disabled={props.ViewMode || disableTotalCost || disableCurrency}
                                                    />
                                                </Col>
                                                <Col md={3} className='px-2'>
                                                    <TextFieldHookForm
                                                        label={`Percentage (%)`}
                                                        name={'Percentage'}
                                                        Controller={Controller}

                                                        control={control}
                                                        register={register}
                                                        mandatory={true}
                                                        rules={{
                                                            required: false,
                                                            validate: { number, checkWhiteSpaces, percentageLimitValidation },
                                                            max: {
                                                                value: 100,
                                                                message: 'Percentage cannot be greater than 100'
                                                            },
                                                        }}
                                                        handleChange={onPercentChange}
                                                        defaultValue={''}
                                                        className=""
                                                        customClassName={'withBorder'}
                                                        errors={errors.Percentage}
                                                        disabled={props.ViewMode}
                                                    />
                                                </Col ></>}
                                        {!props.rawMaterial && <Col md={3} className={'px-2'}>

                                            <TextFieldHookForm
                                                label={`Cost (${Currency}${UOM ? `/${UOM}` : ''})`}
                                                name={'CostCurrency'}
                                                id={'cost-by-percent'}
                                                Controller={Controller}

                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                rules={{
                                                    required: true,
                                                    validate: { number, checkWhiteSpaces, decimalNumberLimit6 },
                                                }}
                                                handleChange={handleCostChangeCurrency}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.CostCurrency}
                                                disabled={type?.label === 'Percentage' ? true : false || state.disableCostCurrency || props.ViewMode}
                                            />
                                        </Col>}
                                        <Col md={3} className={'px-2'}>

                                            <TextFieldHookForm
                                                label={`Cost (${CurrencyLabel}${UOM ? `/${UOM}` : ''})`}
                                                name={'CostBaseCurrency'}
                                                id={'cost-by-percent'}
                                                Controller={Controller}

                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                rules={{
                                                    required: true,
                                                    validate: { number, checkWhiteSpaces, decimalNumberLimit6 },
                                                }}
                                                handleChange={handleCostChangeBase}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.CostBaseCurrency}
                                                disabled={type?.label === 'Percentage' ? true : false || state.disableCostBaseCurrency || props.ViewMode}
                                            />
                                        </Col>
                                        <Col md="3" className='px-2'>
                                            <TextFieldHookForm
                                                label="Remark"
                                                name={"Remark"}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces, hashValidation, maxLength80 }

                                                }}
                                                handleChange={() => { }}
                                                defaultValue={""}
                                                className=""
                                                customClassName={"withBorder"}
                                                errors={errors.Remark}
                                                disabled={props.ViewMode}
                                            />
                                        </Col>
                                        <Col md="3" className={toggleCondition()}>
                                            <button
                                                type="button"
                                                className={"user-btn  pull-left mt-1"}
                                                onClick={addData}
                                                disabled={props.ViewMode || props?.disabled}
                                            >
                                                {isEditMode ? "" : <div className={"plus"}></div>} {isEditMode ? "UPDATE" : 'ADD'}
                                            </button>
                                            <button
                                                type="button"
                                                className={"reset-btn pull-left mt-1 ml5"}
                                                onClick={() => resetData("reset")}
                                                disabled={props.ViewMode || props?.disabled}
                                            >
                                                {isEditMode ? "CANCEL" : 'RESET'}
                                            </button>
                                        </Col >
                                    </Row >
                                    <Col md={props.hideAction ? 12 : 12}>
                                        <Table className="table cr-brdr-main mb-0 forging-cal-table" size="sm">
                                            <tbody>
                                                <tr className='thead'>
                                                    <th>{`Cost`}</th>
                                                    <th>{`Cost Description`}</th>
                                                    <th>{`Type`}</th>
                                                    <th>{`Applicability`}</th>
                                                    {(!props.rawMaterial || isBOP) && <th>{`Applicability Cost (${Currency}${UOM ? `/${UOM}` : ''})`}</th>}
                                                    {!isBOP && <th>{`Applicability Cost (${CurrencyLabel}${UOM ? `/${UOM}` : ''})`}</th>}
                                                    <th>{`Percentage (%)`}</th>
                                                    {(!props.rawMaterial || isBOP) && <th>{`Cost (${Currency}${UOM ? `/${UOM}` : ''})`}</th>}
                                                    {!isBOP && <th>{`Cost (${CurrencyLabel}${UOM ? `/${UOM}` : ''})`}</th>}
                                                    <th>{`Remark`}</th>
                                                    {!props.hideAction && <th className='text-right'>{`Action`}</th>}
                                                </tr>

                                                {tableData && tableData.map((item, index) => (
                                                    <Fragment key={index}>
                                                        <tr>
                                                            <td>{item.CostHeaderName}</td>
                                                            <td>{item.Description}</td>
                                                            <td>{item.Type}</td>
                                                            <td>{item.Applicability}</td>
                                                            {(!props.rawMaterial || isBOP) && <td>{checkForDecimalAndNull(item.ApplicabilityCost, initialConfiguration?.NoOfDecimalForPrice)}</td>}
                                                            {!isBOP && <td>{checkForDecimalAndNull(item.ApplicabilityCostConversion, initialConfiguration?.NoOfDecimalForPrice)}</td>}
                                                            <td>{item.Value !== '-' ? checkForDecimalAndNull(item.Value, initialConfiguration?.NoOfDecimalForPrice) : '-'}</td>
                                                            {(!props.rawMaterial || isBOP) && <td>{item.NetCost !== '-' ? checkForDecimalAndNull(formatDisplayValue(item.NetCost, item.CostHeaderName), initialConfiguration?.NoOfDecimalForPrice) : '-'}</td>}
                                                            {!isBOP && <td>{RawMaterialNonIndexed ? checkForDecimalAndNull(formatDisplayValue(item?.NetCost, item.CostHeaderName), initialConfiguration?.NoOfDecimalForPrice) : checkForDecimalAndNull(formatDisplayValue(item?.NetCostConversion, item.CostHeaderName), initialConfiguration?.NoOfDecimalForPrice)}</td>}
                                                            <td>{item.Remark}</td>
                                                            {!props.hideAction && (
                                                                <td>
                                                                    <div className='text-right'>
                                                                        <button title='Edit' className="Edit mr-1" type='button' onClick={() => editDeleteData(index, 'edit')} disabled={props.ViewMode} />
                                                                        <button
                                                                            title={isCostDependedUpon(item.CostHeaderName, index) ? 'Cannot delete: This cost is used in another row\'s Applicability' : 'Delete'}
                                                                            className="Delete mr-1"
                                                                            type='button'
                                                                            onClick={() => editDeleteData(index, 'delete')}
                                                                            disabled={props.ViewMode || isCostDependedUpon(item.CostHeaderName, index)}
                                                                        />
                                                                    </div>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    </Fragment>
                                                ))}

                                                {tableData && tableData.length === 0 && (
                                                    <tr>
                                                        <td colSpan="10">
                                                            <NoContentFound title={EMPTY_DATA} />
                                                        </td>
                                                    </tr>
                                                )}

                                                <tr className='table-footer'>
                                                    <td colSpan={props.rawMaterial ? 6 : 7} className="text-right font-weight-600 fw-bold">
                                                        <div className="d-inline-flex justify-content-end">
                                                            <span>Total Cost:</span>
                                                            <TooltipCustom
                                                                disabledIcon={false}
                                                                id="other-cost-total-info"
                                                                customClass="ml-1 mt-1"
                                                                width={'260px'}
                                                                placement="top"
                                                                tooltipText="Total = Other costs − Discount. Discount shows positive but is deducted."
                                                            />
                                                        </div>
                                                    </td>
                                                    {!props.rawMaterial &&
                                                        <td>
                                                            <div className='d-flex justify-content-between'>
                                                                <span className={totalCostCurrency < 0 ? 'text-danger' : ''}>
                                                                    {checkForDecimalAndNull(Math.abs(totalCostCurrency), initialConfiguration?.NoOfDecimalForPrice)}
                                                                </span>
                                                                {totalCostCurrency < 0 && (
                                                                    <TooltipCustom
                                                                        disabledIcon={false}
                                                                        id="negative-total-warning"
                                                                        customClass="ml-1"
                                                                        width={'200px'}
                                                                        tooltipText="Negative total indicates discount exceeds other costs"
                                                                    />
                                                                )}
                                                            </div>
                                                        </td>
                                                    }
                                                    <td colSpan={3} className="text-left">
                                                        <span className={(isBOP || RawMaterialNonIndexed ? totalCostCurrency : totalCostBase) < 0 ? 'text-danger' : ''}>
                                                            {checkForDecimalAndNull(Math.abs((isBOP || RawMaterialNonIndexed ? totalCostCurrency : totalCostBase)), initialConfiguration?.NoOfDecimalForPrice)} ({CurrencyLabel})
                                                        </span>
                                                        {(isBOP || RawMaterialNonIndexed ? totalCostCurrency : totalCostBase) < 0 && (
                                                            <TooltipCustom
                                                                disabledIcon={false}
                                                                id="negative-total-base-warning"
                                                                customClass="ml-1"
                                                                width={'200px'}
                                                                tooltipText="Negative total indicates discount exceeds other costs"
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>

                                </div >
                                <Row className="sf-btn-footer no-gutters drawer-sticky-btn justify-content-between mx-0">
                                    <div className="col-sm-12 text-left bluefooter-butn d-flex justify-content-end">
                                        <button
                                            type={'button'}
                                            className="reset cancel-btn mr5"
                                            onClick={cancel || props?.disabled} >
                                            <div className={'cancel-icon'}></div> {'Cancel'}
                                        </button>
                                        <button
                                            type={'button'}
                                            className="submit-button save-btn"
                                            onClick={() => props.closeDrawer('Save', tableData, totalCostCurrency, (isBOP || RawMaterialNonIndexed ? totalCostCurrency : totalCostBase), RowIndex)}
                                            disabled={props.ViewMode || props?.disabled}
                                        >
                                            <div className={"save-icon"}></div>
                                            {'Save'}
                                        </button>
                                    </div>
                                </Row>
                            </form>
                        </div >
                    </Container >
                </div >
            </Drawer >
        </div >
    )
}
export default React.memo(AddOtherCostDrawer)